(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[96559],{

/***/ 62469:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/batch/[slug]/[batchUID]",
      function () {
        return __webpack_require__(75229);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14924);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(35944);
/* harmony import */ var _layout_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41566);
/* harmony import */ var _cont_Batch_Batch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76995);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17579);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52420);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34497);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8100);
/* harmony import */ var _api_hooks_batch_useBatchDetails__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64465);
/* harmony import */ var _api_hooks_batch_useBatchSchedule__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35348);
/* harmony import */ var _api_hooks_batch_useBatchTopicsCovered__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53728);
/* harmony import */ var _api_hooks_batch_useBatchTestSeries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66208);
/* harmony import */ var _api_hooks_batch_useBatchTrialClasses__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91873);
/* harmony import */ var _api_hooks_batch_useBatchFeedback__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62393);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18113);
/* harmony import */ var _cont_App_PageReduxProviderWrapper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27300);
/* harmony import */ var _Analytics_OneLinkSmartScript__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92588);
/* harmony import */ var _api_hooks_batch_useDemoClasses__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35044);


/* ==== Batch page is cached on cdn for 1 hours ==== */ 




// SWR and API functions











var BatchPage = function(param) {
    var batchUID = param.batchUID, fallbackData = param.fallbackData;
    var me = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_selectors_auth__WEBPACK_IMPORTED_MODULE_4__/* .getMe */ .jo);
    var ref = fallbackData || {}, _faqs = ref.faqs, faqs = _faqs === void 0 ? [] : _faqs;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_cont_Batch_Batch__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        batchUID: batchUID,
        me: me,
        faqs: faqs
    });
};
var BatchPageWithSWR = function(param) {
    var goalUID = param.goalUID, batchUID = param.batchUID, fallbackData = param.fallbackData;
    var batchDetailsKey = (0,_api_hooks_batch_useBatchDetails__WEBPACK_IMPORTED_MODULE_6__/* .getKey */ .k)(batchUID);
    var ref = (0,_api_hooks_batch_useBatchSchedule__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(batchUID), batchScheduleKey = ref.key;
    var batchTopicsCoveredKey = (0,_api_hooks_batch_useBatchTopicsCovered__WEBPACK_IMPORTED_MODULE_8__/* .getKey */ .k)(batchUID);
    var batchTestSeriesKey = (0,_api_hooks_batch_useBatchTestSeries__WEBPACK_IMPORTED_MODULE_9__/* .getKey */ .k)(batchUID);
    var batchTrialClassesKey = (0,_api_hooks_batch_useBatchTrialClasses__WEBPACK_IMPORTED_MODULE_10__/* .getKey */ .k)(batchUID);
    var batchfeedbackKey = (0,_api_hooks_batch_useBatchFeedback__WEBPACK_IMPORTED_MODULE_11__/* .getKey */ .k)(goalUID);
    var batchDemoClassKey = (0,_api_hooks_batch_useDemoClasses__WEBPACK_IMPORTED_MODULE_15__/* .getBatchDemoClassesKey */ .yT)(batchUID);
    var accToken = (0,_utils_cookies__WEBPACK_IMPORTED_MODULE_12__/* .readCookie */ .vQ)("accessToken");
    var _obj;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsxs */ .BX)(swr__WEBPACK_IMPORTED_MODULE_5__/* .SWRConfig */ .J$, {
        value: {
            revalidateOnMount: !!accToken,
            dedupingInterval: 60 * 1000,
            fallback: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_obj, batchDetailsKey, fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.batchDetails), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_obj, batchScheduleKey, fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.schedule), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_obj, batchTopicsCoveredKey, fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.topicsCovered), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_obj, batchTestSeriesKey, fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.testSeries), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_obj, batchTrialClassesKey, fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.trialClasses), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_obj, batchfeedbackKey, fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.feedback), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_obj, batchDemoClassKey, fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.demoClasses), _obj)
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(BatchPage, {
                batchUID: batchUID,
                fallbackData: fallbackData
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_Analytics_OneLinkSmartScript__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
        ]
    });
};
BatchPageWithSWR.pageInfo = {
    name: _constants_segment__WEBPACK_IMPORTED_MODULE_2__/* .BATCH_PAGE */ .N5O,
    isCMSMeta: true,
    isMWebSupported: true
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BatchPageWithSWR);
BatchPageWithSWR.Layout = _layout_index__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
BatchPageWithSWR.Wrapper = _cont_App_PageReduxProviderWrapper__WEBPACK_IMPORTED_MODULE_13__["default"];


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [53662,35303,82492,52420,86924,96523,25675,61608,41664,63953,92781,21322,74061,84872,99943,13003,43496,20261,86985,97958,66970,46511,9720,46571,16050,4392,95965,41566,13237,48392,8463,72840,7346,99164,48285,3906,52559,76995,49774,92888,40179], function() { return __webpack_exec__(62469); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);